import React from 'react';

import { PageLayout } from 'src/components/common';
import { spacingStyling } from 'src/constants/spacing';
import { useFilterStorage, useSearchQueryVariables } from 'src/hooks/common';
import { useCurrentPeoStaff } from 'src/hooks/peoStaff';
import { usePeoStaffList } from 'src/hooks/peoStaff/usePeoStaffList';
import { SxProp } from 'src/types/mui';
import { preparePeoStaffFilter } from 'src/utils/peoStaff';

import { PeoStaffTablePeoAdmin } from './PeoStaffTablePeoAdmin';
import { getPeoStaffLabel, prepareSearchStaffsFilter } from './utils';

export const PeoStaffTableWrapperPeoAdmin: React.FC = () => {
  const { peoId, peoStaff } = useCurrentPeoStaff();

  const peoStaffDisplayName = getPeoStaffLabel(peoStaff?.peo.displayName);

  const searchQueryVariables = useSearchQueryVariables(prepareSearchStaffsFilter);
  const { filter, sortQueryVariable, paginationQueryVariables, pagination } = useFilterStorage();
  const filterQueryVariables = React.useMemo(() => preparePeoStaffFilter(filter), [filter]);

  const { peoStaffsList, peoStaffsCount, loading, refetch } = usePeoStaffList(
    {
      filter: {
        peoId: { equals: peoId },
        ...searchQueryVariables,
        ...filterQueryVariables,
      },
      ...paginationQueryVariables,
      orderBy: sortQueryVariable,
    },
    !peoId,
    true,
  );

  const refetchData = React.useCallback(async () => {
    await refetch();
    pagination.resetPage();
  }, [pagination, refetch]);

  return (
    <PageLayout titleContent={peoStaffDisplayName} paperSx={pageLayoutPaperSx}>
      <PeoStaffTablePeoAdmin
        peoStaffList={peoStaffsList}
        peoStaffCount={peoStaffsCount}
        onRefresh={refetchData}
        pagination={pagination}
        loading={loading}
      />
    </PageLayout>
  );
};

const pageLayoutPaperSx: SxProp = {
  p: spacingStyling.peoTable,
  mt: 3,
};
